<template>
  <div>
    <HeadBar />
    <!--顶部bar-->
    <HeadNav /><!-- 顶部导航-->
    <div class="expert">
      <div class="expert-inner" v-loading="loading">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
          <el-breadcrumb-item :to="{ name: 'home' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'expertsList' }"
            >列表</el-breadcrumb-item
          >
          <el-breadcrumb-item>详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="expert-con">
          <div class="brief flex flex-row">
            <div class="brief-cover">
              <img v-if="detail.expertImage" :src="detail.expertImage" />
              <img v-else :src="$oss('common/empty-img-expert.png')" />
            </div>
            <div class="flex-1">
              <div class="flex flex-middle">
                <div class="brief-name">
                  {{ detail.userRealName }}
                </div>
                <div class="brief-title">
                  <span v-if="detail.expertUniversity">
                    {{ detail.expertUniversity }}
                  </span>
                  <!--<span v-if="detail.expertPositionTitle">
                    {{ eduMap[+detail.expertEducation] }}
                  </span>-->
                  <span>{{ detail.expertPositionTitle }}</span>
                </div>
              </div>
              <!-- <div class="brief-tags">
                <el-tag type="success" v-if="detail.expertUniversity">{{
                  detail.expertUniversity
                }}</el-tag>
                <el-tag type="warning">{{
                  eduMap[+detail.expertEducation]
                }}</el-tag>
                <el-tag v-if="detail.expertPositionTitle">{{
                  detail.expertPositionTitle
                }}</el-tag>
              </div> -->
              <!-- <div class="brief-btn">
                <span class="pointer" @click="toEvaluation">申请评估</span>
              </div> -->
              <div class="brief-detail flex flex-middle">
                <div class="brief-list flex flex-row">
                  <div class="brief-item brief-item1">
                    擅长：{{ detail.fieldExesStr }}
                  </div>
                </div>
                <div class="flex flex-row">
                  <div class="brief-list flex flex-row brief-m-right">
                    <!-- <div><i class="el-icon-folder-opened"></i></div> -->
                    <div class="brief-item brief-item2">
                      专业：{{ detail.expertProfessional || `暂无` }}
                    </div>
                  </div>
                  <!-- <div class="brief-list flex flex-row brief-m-right">
                  <div><i class="el-icon-phone"></i></div>
                  <div>
                    <label>电话</label>
                    <span></span>
                  </div>
                </div>
                <div class="brief-list flex flex-row">
                  <div><i class="el-icon-message"></i></div>
                  <div>
                    <label>邮箱</label>
                    <span></span>
                  </div>
                </div> -->
                </div>
              </div>

              <div>
                <!-- <div class="detail-title">专家介绍</div> -->
                <div class="detail-desc">{{ detail.expertBrief }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ApplyDialog v-model="dialogVisible" />
    <FootBar class="footer" />
  </div>
</template>
<script>
import ApplyDialog from "./components/ApplyDialog";
import { expertDetail } from "@/api/expert";
import { EDU_GRADE } from "@/constant/dict";
import { mapGetters } from "vuex";
export default {
  components: {
    ApplyDialog,
  },
  data() {
    return {
      dialogVisible: false,
      detail: {},
      loading: false,
      eduMap: {},
    };
  },
  computed: {
    ...mapGetters(["token"]),
  },
  created() {
    this.getDict();
    this.getDetail();
  },
  methods: {
    async getDict() {
      const res = await this.$store.dispatch("getDictData", EDU_GRADE);
      const eduMap = {};
      res.forEach((item) => {
        eduMap[item.dictValue] = item.dictLabel;
      });
      this.eduMap = eduMap;
    },
    async getDetail() {
      this.loading = true;
      const res = await this.$axios
        .get(expertDetail, { expertId: this.$route.query.id })
        .finally(() => {
          this.loading = false;
        });
      const { fieldExes } = res;
      if (fieldExes && fieldExes.length) {
        res.fieldExesStr = fieldExes
          .map((item) => item.fieldCategoryName)
          .join(", ");
      }

      this.detail = res;
    },
    toEvaluation() {
      if (!this.token) {
        this.$store.dispatch("login");
        return;
      }
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.breadcrumb {
  margin-bottom: 10px;
}
.expert {
  min-height: 550px;
  background: $home-bg;
  padding-top: 20px;
  padding-bottom: 20px;
  &-inner {
    width: $max-width;
    margin: auto;
  }
  &-con {
    background: white;
    min-height: 500px;
    padding: 35px 40px;
  }
}
.footer {
  padding-top: 0;
}
.brief {
  margin-bottom: 48px;
  &-cover {
    width: 224px;
    height: 250px;
    margin-right: 30px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &-little {
    margin-bottom: 20px;
  }
  &-name {
    font-size: 32px;
    font-weight: 400;
    color: #333333;
    margin-bottom: 10px;
  }
  &-title {
    font-size: 18px;
    margin-left: 15px;
  }
  &-item {
    color: white;
    padding: 5px 10px;
  }
  &-item1 {
    background: $theme-color;
    margin-right: 12px;
  }
  &-item2 {
    background: #ff9531;
  }
  &-tags {
    margin-bottom: 20px;
    > span {
      margin-right: 20px;
    }
  }
  // &-btn {
  //   margin-bottom: 36px;
  //   span {
  //     color: white;
  //     background: #4482ff;
  //     padding: 8px 28px;
  //     display: inline-block;
  //   }
  // }
  &-detail {
    // background: #f5faff;
    padding: 20px 0 0;
  }
  &-m-bottom {
    margin-bottom: 18px;
  }
  &-m-right {
    margin-right: 75px;
  }
  &-list {
    i {
      background: #b6ceff;
      color: white;
      border-radius: 50%;
      padding: 4px;
      margin-right: 13px;
    }
    label {
      margin-right: 5px;
      color: #666666;
    }
  }
}
.detail {
  // &-border {
  //   border-left: 4px solid #4482ff;
  //   margin-right: 12px;
  // }
  &-title {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    position: relative;
    padding-left: 15px;
    margin-bottom: 20px;
    &::before {
      content: "";
      display: inline-block;
      position: absolute;
      left: 0;
      top: 4px;
      width: 4px;
      background: #4482ff;
      height: 18px;
    }
    &::after {
      content: "";
      display: inline-block;
      position: absolute;
      right: 0;
      top: 12px;
      width: 90%;
      background: #ebebeb;
      height: 1px;
    }
  }
  &-desc {
    margin-top: 20px;
    padding: 30px 0 0;
    line-height: 35px;
    color: #6b7474;
    border-top: 1px solid #ebebeb;
  }
}
</style>
